module.exports = require('./getLayoutsFromApps')
